import React, { useRef, useState, useEffect } from "react";
import { setStorage, getStorage, deleteStorage } from "../modals/Storage";
import {
    WEBSITE_NAME,
    API_ACCESS_URL,
    AVATARS_ARR
} from "../modals/Constants";
import { Link, useNavigate } from "react-router-dom";
import SlideShow from "../other-components/SlideShow";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import general from "../css/General.module.css";
import DialogConfirm from "../dialogs/DialogConfirm/dialog";

function Dashboard() {
    const navigate = useNavigate();
    const toastDialogRef = useRef(null);
    const dialogConfirmRef = useRef(null);
    const [isLoadingShow, setLoadingShow] = useState(false);
    const [marketPricing, setMarketPricing] = useState(null);
    const [marketSelected, setMarketSelected] = useState(1);

    const [pageConst, setConstants] = useState({
        accountId: "",
        accountBalance: 0,
        isDataLoaded: false,
        recordList: [],
        sliderImages: [],
    });

    const [noticeDialogConst, setNoticeDialogConst] = useState({
        noticeTitle: "",
        noticeNote: "",
        noticeDialogShow: false,
    });

    const signOutAccount = () => {
        if (deleteStorage()) {
            navigate("/login", { replace: true });
        }
    };

    // toast component
    const onToastChange = (data, msg) => { };

    const showToast = (message, duration, delay, mode) => {
        toastDialogRef.current.openDialog(message, duration, delay, mode);
    };


    // dialog confrim component
    const onDialogConfirm = (data, msg) => {
        signOutAccount();
    };

    const showDialogConfirm = (message, delay, mode) => {
        dialogConfirmRef.current.openDialog(message, delay, mode);
    };

    const updateSliderImagesArr = (data) => {
        if (data.length > 0) {
            setConstants((previousState) => {
                return { ...previousState, sliderImages: data };
            });
        }
    };

    function getAccountInfo() {
        const fecthApiData = async (url, authSecret) => {
            try {
                const res = await fetch(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Route: "route-account-info",
                        AuthToken: authSecret,
                    },
                });
                const data = await res.json();
                setLoadingShow(false);

                if (data.status_code == "success") {
                    let accountAvatarId = data.data[0]["account_avatar_id"];
                    let accountUserName = data.data[0]["account_user_name"];
                    let accountBalance = data.data[0]["account_balance"];
                    let accountWinningBalance = data.data[0]["account_w_balance"];
                    let accountLevel = data.data[0]["account_level"];
                    let accountLastActive = data.data[0]["account_last_active"];

                    let service_app_status = data.data[0]["service_app_status"];
                    let service_min_recharge = data.data[0]["service_min_recharge"];
                    let service_recharge_option = data.data[0]["service_recharge_option"];
                    let service_telegram_url = data.data[0]["service_telegram_url"];
                    let service_payment_url = data.data[0]["service_payment_url"];
                    let service_livechat_url = data.data[0]["service_livechat_url"];
                    let service_imp_message = data.data[0]["service_imp_message"];
                    let service_app_download_url =
                        data.data[0]["service_app_download_url"];

                    setStorage("avatarId", accountAvatarId);
                    setStorage("uname", accountUserName);
                    setStorage("balance", accountBalance);
                    setStorage("wbalance", accountWinningBalance);
                    setStorage("accountLevel", accountLevel);
                    setStorage("accountLastActive", accountLastActive);
                    setStorage("minrecharge", service_min_recharge);
                    setStorage("rechargeoptions", service_recharge_option);
                    setStorage("telegramURL", service_telegram_url);
                    setStorage("liveChatURL", service_livechat_url);
                    setStorage("paymentURL", service_payment_url);
                    setStorage("impMessage", service_imp_message);
                    setStorage("appDownloadURL", service_app_download_url);
                    setConstants({
                        ...pageConst,
                        accountBalance: accountBalance,
                        isDataLoaded: true,
                    });

                    if (service_app_status == "OFF") {
                        navigate("/um", { replace: true });
                    } else {
                        // showNotice(data.noticeArr);
                        updateSliderImagesArr(data.slideShowList);
                    }
                } else if (data.status_code == "authorization_error") {
                    signOutAccount();
                }
            } catch (error) {
                setLoadingShow(false);
            }
        };

        if (!isLoadingShow && !pageConst.isDataLoaded) {
            setLoadingShow(true);
            fecthApiData(API_ACCESS_URL + "?USER_ID=" + getStorage("uid"), getStorage("secret"));
        }
    }

    function isTrue() {
        return Math.random() < 0.5;
    }

    function getCurrencyMovement() {
        return (Math.random() * (0.10000 - 0.00001) + 0.00001).toFixed(5);
    }

    function getCurrencyPrice(currency) {
        if (currency == "BTC") {
            return (Math.random() * (69000 - 67000) + 67000).toFixed(2);
        } else if (currency == "ETC") {
            return ((Math.random() * (18 - 17.50)) + 17.50).toFixed(2);
        } else if (currency == "BNB") {
            return ((Math.random() * (600 - 540)) + 540).toFixed(2);
        } else if (currency == "LTC") {
            return ((Math.random() * (71 - 64)) + 64).toFixed(2);
        } else if (currency == "TRX") {
            return ((Math.random() * (14 - 13)) + 13).toFixed(2);
        }
    }

    function graphMaker() {
        const marketList = (
            <>
                <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-20'>
                    <div>BTC/<span className='cl-l-grey'>USDT</span></div>
                    <div>{getCurrencyPrice("BTC")}</div>
                    {isTrue() ?
                        <div className='v-center cl-green-new'>
                            <img
                                src={require("../media/icons/up_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>
                        :
                        <div className='v-center cl-red-new'>
                            <img
                                src={require("../media/icons/down_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>}
                </div>

                <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-15'>
                    <div>ETC/<span className='cl-l-grey'>USDT</span></div>
                    <div>{getCurrencyPrice("ETC")}</div>
                    {isTrue() ?
                        <div className='v-center cl-green-new'>
                            <img
                                src={require("../media/icons/up_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>
                        :
                        <div className='v-center cl-red-new'>
                            <img
                                src={require("../media/icons/down_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>}
                </div>

                <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-15'>
                    <div>BNB/<span className='cl-l-grey'>USDT</span></div>
                    <div>{getCurrencyPrice("BNB")}</div>
                    {isTrue() ?
                        <div className='v-center cl-green-new'>
                            <img
                                src={require("../media/icons/up_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>
                        :
                        <div className='v-center cl-red-new'>
                            <img
                                src={require("../media/icons/down_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>}
                </div>

                <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-15'>
                    <div>LTC/<span className='cl-l-grey'>USDT</span></div>
                    <div>{getCurrencyPrice("LTC")}</div>
                    {isTrue() ?
                        <div className='v-center cl-green-new'>
                            <img
                                src={require("../media/icons/up_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>
                        :
                        <div className='v-center cl-red-new'>
                            <img
                                src={require("../media/icons/down_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>}
                </div>

                <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-15'>
                    <div>TRX/<span className='cl-l-grey'>USDT</span></div>
                    <div>{getCurrencyPrice("TRX")}</div>
                    {isTrue() ?
                        <div className='v-center cl-green-new'>
                            <img
                                src={require("../media/icons/up_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>
                        :
                        <div className='v-center cl-red-new'>
                            <img
                                src={require("../media/icons/down_icon.png")}
                                className="h-15-p"
                                alt="icon"
                            />
                            &nbsp; {getCurrencyMovement()}
                        </div>}
                </div>
            </>
        );

        setMarketPricing(marketList);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            graphMaker();
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        graphMaker();
    }, [marketSelected])

    useEffect(() => {
        if (!getStorage("uid")) {
            signOutAccount();
        } else {
            getAccountInfo();
        }
    }, []);

    return (
        <div
            className={[
                general.appContents,
            ].join(" ")}>
            <LoadingDialog intentData={isLoadingShow} />
            <DialogConfirm onConfirmed={onDialogConfirm} ref={dialogConfirmRef} />

            <div
                className={[
                    general.posRelative,
                    general.respWidth,
                    general.height100vh,
                    general.overflowScrollY,
                    general.hideScrollBar,
                ].join(" ")}
            >
                <div className="w-100 ps-sticky ps-tp row-view pd-15 z-i-90 bg-custom-1">
                    <div className="w-100 row-view sb-view">
                        <Link className="row-view txt-deco-n" to={"/updateaccount"}>
                            {getStorage("avatarId") ? (
                                <img
                                    src={
                                        AVATARS_ARR[Number(getStorage("avatarId")) - 1]["avatarURL"]
                                    }
                                    className="h-w-45 br-50 ovf-hidden"
                                    alt="icon"
                                />
                            ) : (
                                <img
                                    src={require('../media/icons/avatar_icon.png')}
                                    className="h-w-45"
                                    alt="icon"
                                />
                            )}

                            <div className="col-view mg-l-10">
                                <p className="ft-sz-22 cl-white">
                                    {getStorage("uname") ? getStorage("uname").length > 18
                                        ? getStorage("uname").slice(0, 18) + '...'
                                        : getStorage("uname") : 'Loading..'}
                                </p>
                                <p className="ft-sz-16 cl-l-white">Balance: ₹{getStorage("balance")}</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="mg-t-10">
                    <SlideShow dataList={pageConst.sliderImages} />
                </div>

                <div className='pd-15 bg-custom-1 mg-t-10'>
                    <div className="w-fit-content v-center ft-sz-18 cl-white"><i className='bx bx-info-circle'></i>&nbsp;Live Market</div>

                    <div className='w-100 ft-sz-14 row-view cl-white ovf-scrl-x mg-t-20 hide-sb'>
                        <div className={`pd-5-15 br-20 ${marketSelected == 1 ? 'bg-selected' : 'bg-tar-black'}`} onClick={() => setMarketSelected(1)}>Huobipro</div>
                        <div className={`pd-5-15 mg-l-5 br-20 ${marketSelected == 2 ? 'bg-selected' : 'bg-tar-black'}`} onClick={() => setMarketSelected(2)}>Okex</div>
                        <div className={`pd-5-15 mg-l-5 br-20 ${marketSelected == 3 ? 'bg-selected' : 'bg-tar-black'}`} onClick={() => setMarketSelected(3)}>Binance</div>
                        <div className={`pd-5-15 mg-l-5 br-20 ${marketSelected == 4 ? 'bg-selected' : 'bg-tar-black'}`} onClick={() => setMarketSelected(4)}>Coinbase</div>
                    </div>

                    <div className='w-100 ft-sz-14 row-view sb-view cl-white mg-t-30'>
                        <div>Name</div>
                        <div className='mg-l-20'>Price</div>
                        <div>Movement</div>
                    </div>

                    <div>{marketPricing}</div>

                </div>

                <div className="pd-15 mg-t-10 bg-custom-1">
                    <div className="w-fit-content v-center ft-sz-18 cl-white"><i className='bx bx-info-circle'></i>&nbsp;About Platform</div>

                    <div className="cl-l-white-2 mg-t-20">
                        <div className="ft-sz-16">
                            Welcome to {WEBSITE_NAME}, your trusted partner in the world of online trading. Our platform is designed to make trading seamless, efficient, and accessible for everyone, whether you're a seasoned trader or just getting started.

                            At {WEBSITE_NAME}, we aim to empower users with advanced tools and resources to make informed trading decisions. Here's how our platform works:
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            1. *User-Friendly Interface*: We've created an intuitive and easy-to-navigate interface, allowing you to trade and track your investments effortlessly. Whether you're accessing from a desktop or mobile device, the experience is smooth and responsive.
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            2. *Wide Range of Assets*: Trade a diverse range of assets, including stocks, forex, cryptocurrencies, commodities, and more. Our platform connects you to global markets, giving you endless opportunities for growth.
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            3. *Real-Time Data & Analytics*: Stay ahead of the market with real-time data, charts, and advanced technical analysis tools. Get up-to-the-minute updates to help you make smarter decisions.
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            4. *Secure Transactions*: Your security is our priority. We employ industry-leading encryption and security protocols to ensure that your funds and personal data are always protected.
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            5. *Automated Trading Features*: Take advantage of our automated trading tools to execute trades based on pre-set parameters, reducing the need for constant monitoring and enhancing your trading strategy.
                        </div>
                        <br></br>

                        <div className="ft-sz-14 mg-t-10">
                            6. *Learning Resources*: Whether you are a beginner or an experienced trader, we provide comprehensive educational resources to help you sharpen your trading skills and stay informed about market trends.
                        </div>

                        <br></br>
                        <div>
                            At {WEBSITE_NAME}, we believe that the right tools and knowledge can help you succeed in the ever-changing world of trading. Our mission is to simplify the process and offer a platform where you can trade with confidence.

                            Start trading today with {WEBSITE_NAME}, where simplicity meets power.
                        </div>
                    </div>
                </div>


                <div className="pd-15 mg-t-10 mg-b-10em bg-custom-1">
                    <div className="row-view">
                        <img
                            src={require('../media/icons/customer_service_icon.png')}
                            className="w-30-p"
                            alt="icon"
                        />
                        <p className="ft-sz-18 cl-white mg-l-5">Need Help?</p>
                    </div>

                    <p className="ft-sz-14 cl-l-white mg-t-15">Need Help then please contact us now to resolve any pending issue.</p>

                    <Link className="d-block txt-deco-n ft-sz-18 pd-10-20 cl-white mg-t-10 br-5 bg-green" to={"/helpsupport"}>Contact us</Link>
                </div>

                <BottomNavbar activeBar="dashboard" />

            </div>
        </div>
    );
}

export default Dashboard;